/* LG zoom — tap-to-zoom viewer for the label panel (lg-exhibit-plate). Ported from biostack-theme/assets/bs-zoom.js.
   Opens a <dialog>, sizes the image so the focus region (data-focus-* in % of
   the image) fills the viewer, scrolls to it, and lets the shopper pan by
   touch, wheel or drag. Native pinch-zoom still works inside the pan box. */
(function () {
  function open(dlg) {
    var pan = dlg.querySelector('[data-zoom-pan]'), img = pan && pan.querySelector('img');
    if (!pan || !img) return;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('lg-zoom-open');
    var fx = +dlg.dataset.focusX / 100, fy = +dlg.dataset.focusY / 100, fw = +dlg.dataset.focusW / 100, fh = +dlg.dataset.focusH / 100;
    var vw = pan.clientWidth, vh = pan.clientHeight;
    var ratio = (img.naturalHeight || +img.getAttribute('height')) / (img.naturalWidth || +img.getAttribute('width')) || 1;
    /* Scale so the focus box fits the viewer with a small margin. Floor: the
       whole image fitted inside the viewer (so flat artwork is never cropped
       on a wide screen); on a phone that floor is the viewer width. */
    var byW = (vw * 0.94) / fw, byH = (vh * 0.9) / (fh * ratio);
    var fit = Math.min(vw, vh / ratio);
    var w = Math.max(fit, Math.min(byW, byH));
    img.style.width = Math.round(w) + 'px';
    img.style.margin = w < vw ? '0 auto' : '0';
    var h = w * ratio;
    pan.scrollLeft = Math.max(0, fx * w - (vw - fw * w) / 2);
    pan.scrollTop = Math.max(0, fy * h - (vh - fh * h) / 2);
    var closeBtn = dlg.querySelector('[data-zoom-close]'); if (closeBtn) closeBtn.focus();
  }
  function close(dlg) {
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    document.documentElement.classList.remove('lg-zoom-open');
  }
  function drag(pan) {
    var down = false, sx = 0, sy = 0, sl = 0, st = 0;
    pan.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; sx = e.clientX; sy = e.clientY; sl = pan.scrollLeft; st = pan.scrollTop; pan.classList.add('is-dragging'); pan.setPointerCapture(e.pointerId); });
    pan.addEventListener('pointermove', function (e) { if (!down) return; pan.scrollLeft = sl - (e.clientX - sx); pan.scrollTop = st - (e.clientY - sy); });
    function up() { down = false; pan.classList.remove('is-dragging'); }
    pan.addEventListener('pointerup', up); pan.addEventListener('pointercancel', up);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-zoom-open]');
    if (o) { var dlg = document.getElementById(o.getAttribute('data-zoom-open')); if (dlg) { e.preventDefault(); var im = dlg.querySelector('img'); if (im && !im.complete) { im.addEventListener('load', function () { open(dlg); }, { once: true }); im.loading = 'eager'; if (im.complete) open(dlg); } else open(dlg); } return; }
    var c = e.target.closest('[data-zoom-close]');
    if (c) { close(c.closest('dialog')); return; }
    var d = e.target.closest('dialog.lg-zoom');
    if (d && e.target === d) close(d); /* backdrop click: the dialog box itself, outside .lg-zoom__pan */
  });
  document.addEventListener('close', function (e) { if (e.target.matches && e.target.matches('dialog.lg-zoom')) document.documentElement.classList.remove('lg-zoom-open'); }, true);
  document.querySelectorAll('dialog.lg-zoom [data-zoom-pan]').forEach(drag);
})();
